<template>
    <v-container class="w-100 h-100 d-flex justify-center algin-center">
        <v-container class="login" >
            <v-card elevation="0" class="rounded-lg">
                <v-card-title class="text-h5 font-weight-bold d-flex align-center mt-5">
                    Авторизация
                </v-card-title>
                <v-card-text class="pt-3 pb-6">
                    <v-text-field v-model="formLogin.email" :error="!!errors.email" :error-messages="errors.email" label="Email (Логин)" variant="outlined" 
                                outlined />
                    <v-text-field v-model="formLogin.password" type="password" :error="!!errors.password" variant="outlined"
                                        :error-messages="errors.password" label="Пароль"/>
                    <v-btn  color="btnColor" @click="login" variant="flat" rounded="lg" block class="py-7 text-white font-weight-bold" :loading="loading">
                        Войти
                    </v-btn>
                    <v-btn @click="aonkIdLogin()"
                        variant="tonal"
                        color="blue"
                        class="text-body-2 py-7 mt-2"
                        style="border: 2px solid rgba(var(--v-theme-btnColor), 1)"
                        height="50"
                        block
                        rounded="lg">
                        <template #prepend>
                            <v-img src='https://id.ao-nk.ru/favicon.png' width="32"/>
                        </template>
                        Войти через АОНК ID
                    </v-btn>

                </v-card-text>

                <v-divider />
                <v-card-actions class="py-6 pl-5 pr-5 d-flex justify-space-between">
                        <!-- <router-link to="/register" class="text-body-1 font-weight-bold " >Регистрация</router-link> -->
                        <router-link to="/restore-request" class="text-body-1 d-flex justify-end font-weight-bold" color="primary">Восстановить пароль</router-link>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-container>
    <v-dialog v-model="aonkIdDialog" width="600px" scrollable="" >
        <div class="text-right">
            <v-btn icon="mdi-close" variant="flat" color="red" size="small" @click="aonkIdDialog = false"/>
        </div>
        <v-card rounded="lg">
            <iframe :src="aonkIdParams.url+'?'+queryString" id="aonkId" height="900px"></iframe>
        </v-card>
   </v-dialog>

</template>


<script>

import aonkIdParams from '@/plugins/aonkId.js'

export default {
    data(){
        return{
            errors:{},
            loading: false,
            formLogin:{
                email: null,
                password: null,
            },
            items: [],
            aonkIdParams: aonkIdParams,
            aonkIdDialog: false
        }
    },
    methods:{
        login() {
            this.loading = true
            let data = { ...this.formLogin }

            this.$auth.login({
                redirect: false,
                data: data
            }).then(() => {
                this.$router.push({ name: 'app' })
            }).catch(err => {
                console.log(err);
                this.errors = err.response
            })
            .finally(() => {
                this.loading = false
            })
        },
        aonkIdLogin() {
            this.$auth.oauth2('aonkId',{});
        },
        oAuthLogin() {
        //авторизация при получении кода
            this.$auth.oauth2('aonkId',
                {
                    url:'oauth/login',
                    type: 'POST',
                    code: true,
                    redirect: "/app",
                    state: this.$route.query.authorizationCode,
                    data: {
                        authorizationCode: this.$route.query.authorizationCode
                    }
                })
        },


    },
    computed: {
        queryString(){
            let q=this.aonkIdParams.params;
            return Object.keys(q).map(k=>k +'='+ q[k]).join('&').replace("next=","")
        },
    },
    mounted(){
        if(this.$auth.check()) this.$router.push({ name: 'app' })
        if (this.$route.query.authorizationCode) {
            this.oAuthLogin()
        }

    }

}

</script>

<style scoped>

.login{
    width: 100%;
    max-width: 550px;
}

</style>